import axios from "axios"
import { url } from "../../weburl"
import { Link, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import dogpic from '../images/logo1.jpg'
import DogCard from "../../home/dog_card"
import Profile_pic from '../images/profile-avatar.png'
import { Community_Nav } from "../community_nav"
import { dogUrlGenerator } from "../../../util.js/dogUrlGenerator"
import './index.css'
import { PostCard } from "../posts/post_card"



export const UserPublicProfile = () => {
    const params = useParams()
    const [userData, setUserData] = useState()
    const [userDogs, setUserDogs] = useState([])
    const [userPosts, setUserPosts] = useState([])
    const [numberOfDogs, setNumberOfDogs] = useState("N/A")
    const [numberOfPosts, setNumberOfPosts] = useState('N/A')

    useEffect(() => {
        getUserDogs()
        getUserInformation()
        getUserPosts()
    }, [])

    useEffect(() => {
        if (userDogs) {
            setNumberOfDogs(userDogs.length)
        }
        if (userPosts){
            setNumberOfPosts(userPosts.length)

        }
    }, [userDogs, userPosts])

    const getUserInformation = () => {
        axios
            .get(`${url}api/users/getone-generic/${params.id}`)
            .then((res) => setUserData(res.data))
            .catch((err) => console.log(err))
    }

    const getUserDogs = () => {
        axios
            .get(`${url}api/dogs/getdoguser/${params.id}`)
            .then((res) => setUserDogs(res.data))
            .catch((err) => console.log(err))
    }

    const getUserPosts = () => {
        axios
            .get(`${url}api/posts/${params.id}`)
            .then((res) => setUserPosts(res.data))
            .catch((err) => console.log(err))
    }

    const displayGenInfo = () => {
        if (userData) {
            return userData.map((item) => {
                return (
                    <div className="row align-items-center justify-content-center pb-5">
                        <div className="col-sm-5">

                            {item['public_id'] ?
                                <img src={`https://res.cloudinary.com/daurieb51/image/upload/${item['public_id']}.png`}
                                    className='img-fluid profile-account-image brand-yellow-border brand-yellow-box-shadow p-2'
                                    style={{ borderRadius: "50%" }} />
                                :
                                <img src={Profile_pic}
                                    className='img-fluid profile-account-image brand-yellow-border brand-yellow-box-shadow'
                                    style={{ borderRadius: "50%" }} />
                            }

                        </div>
                        <div className="col-sm-5 justify-content-center justify-content-md-start align-items-start
                        align-items--md-center
                         text-left text-md-left px-5 py-4 pt-md-0 px-md-0">
                            <h1 className="d-inline brand-yellow-font text-center">{item['username']}</h1>
                            <hr />
                            <div>
                                <p>{numberOfDogs} dogs registered </p>
                                <p>{numberOfPosts} posts </p>

                            </div>
                            <div>


                                <p>Address: {item['contact_address'] || "N/A"}</p>

                            </div>

                            {/* <div>
                                <button className="follow-button px-4 py-2 mr-2">Follow</button>
                                <button className="message-button px-4 py-2">Message</button>
                            </div> */}

                        </div>
                    </div >

                )
            })


        }

    }

    const displayUserDogs = () => {
        if (userDogs) {
            return userDogs.slice(0, 8).map((item) => {
                return (
                    <div className="col-sm-3">
                        <Link to={`/my_dogs/${item['id']}
                        /${dogUrlGenerator(item['name'])}`}>                            <DogCard
                                image_src={dogpic}
                                dog_id={item['id']}
                                dogname={item['name']}
                                dog_public_id={item['public_id']}
                            />
                        </Link>
                    </div>
                )
            })
        }
    }


    const displayUserPosts = () => {
        if (userPosts) {
            return userPosts.slice(0, 6).map((item) => {
                return (
                    <div className="col-sm-4">
                        <PostCard
                            user_id={item['user']}
                            post_id={item["_id"]}
                            post_content={item['content']}
                            post_image={`https://res.cloudinary.com/daurieb51/image/upload/v1654276166/${item['image_public_id']}.jpg`}
                            time={item['timestamp']}
                            likes={item['likes']}
                            ingeneralPublicProfile={true}
                        />

                    </div>
                )
            })
        }
    }
    return (
        <div className="">
            <Community_Nav />

            <div className="container">

                {displayGenInfo()}
                <div className="row align-items-center justify-content-center">
                    <div className="col-sm-12">
                        <div className="">
                            <p className="text-left">See all dogs belonging to {userData && userData[0]['username']}
                            </p>
                            <div className="row align-items-start justify-content-center">
                                {displayUserDogs()}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center justify-content-center">
                    <div className="col-sm-12">
                        <div className="">
                            <p className="text-left">See all <span className="font-weight-bold">posts</span> belonging to {userData && userData[0]['username']}
                            </p>
                            <div className="row align-items-start justify-content-center">
                            {displayUserPosts()}

                            </div>
                        </div>
                    </div>
                </div>
              
            </div>
        </div>
    )
}